import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import brainImg from '../assets/brain.jpeg';

const Placeholder: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-end sm:items-center overflow-hidden">
      <motion.img
        src={brainImg}
        alt=""
        initial={{ scale: 1.06, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 w-full h-full object-cover object-[center_40%]"
        aria-hidden
      />

      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(105deg, rgba(5,10,20,0.92) 0%, rgba(5,10,20,0.72) 38%, rgba(5,10,20,0.35) 62%, rgba(5,10,20,0.55) 100%), linear-gradient(180deg, rgba(5,10,20,0.4) 0%, transparent 40%, rgba(5,10,20,0.8) 100%)',
        }}
        aria-hidden
      />

      <motion.div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0.35, 0.55, 0.35] }}
        transition={{ delay: 0.6, duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        style={{
          background:
            'radial-gradient(ellipse 42% 38% at 58% 45%, rgba(56,189,248,0.18) 0%, transparent 70%)',
        }}
      />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 pt-28 pb-20 sm:pb-28">
        <div className="max-w-xl">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-5"
          >
            Voxelary
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.12, duration: 0.85, ease: 'easeOut' }}
            className="text-xl sm:text-2xl md:text-3xl font-medium text-white/90 tracking-tight leading-snug mb-5"
          >
            The AI-driven future of medicine
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.28, duration: 0.85, ease: 'easeOut' }}
            className="text-base sm:text-lg text-white/65 leading-relaxed mb-10 max-w-md"
          >
            Exploring how artificial intelligence can advance medicine —
            clarity, insight, and better care for the road ahead.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.75, ease: 'easeOut' }}
          >
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-white text-voxelary-900 font-semibold text-sm hover:bg-white/90 transition-colors"
            >
              Get in Touch
            </Link>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.85, duration: 1 }}
            className="mt-14 text-white/30 text-xs tracking-wide"
          >
            Coming soon
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default Placeholder;
